export default class Superimpose {
  constructor(options = {}) {
    this._tech = options.tech
    this._data = options.data
    this.adState = options.adState
    this._started = false
    this._gptDisplayCalled = false
    this._container = null
  }

  get tech() {
    return this._tech
  }

  get data() {
    return this._data
  }
  
  get started() {
    return this._started
  }

  set started(value) {
    this._started = value
  }

  get gptDisplayCalled() {
    return this._gptDisplayCalled
  }

  set gptDisplayCalled(value) {
    this._gptDisplayCalled = value
  }

  get container() {
    return this._container
  }

  set container(value) {
    this._container = value
  }

  start() {
    if(this.started) return
    
    if(this.shouldTriggerSuperimposeAd()) {
      this.started = true
      this.adState.tryUpdateShownAd('superimpose', this.show.bind(this), this.hide.bind(this));
    }
  }

  shouldTriggerSuperimposeAd() {
    if(!this.gptDefined()) return false

    return true
  }

  show() {
    if (this.container == null) {
      this.appendSuperimposeContainer()
    } else {
      this.container.classList.remove('hidden')
    }

    if(this.gptDisplayCalled) {
      window.googletag.cmd.push(this.refreshAd());
    } else {
      window.googletag.cmd.push(this.displayAd());
      this.gptDisplayCalled = true
    }
  }

  hide() {
    if(!this.started) return
    
    this.started = false

    this.adState.tryResetShownAd('superimpose')

    this.container?.classList.add('hidden');
  }

  refreshAd() {
    return () => {
      window.googletag.pubads().refresh([window.kmklabs.gpt.superimpose])
    }
  }

  displayAd() {
    return () => {
      window.googletag.display(window.kmklabs.gpt.superimpose)
    }
  }

  appendSuperimposeContainer() {
    this.container = this.createSuperimposeContainer()
    this.tech.el().el().append(this.container);
  }

  createSuperimposeContainer() {
    const container = document.createElement('div');
    container.id = 'superimposeContainer'
    container.className = 'superimpose-container';
    container.innerHTML = `<div id="superimpose"></div>`

    return container;
  }

  gptDefined() {
    return window.googletag?.apiReady && window.kmklabs.gpt?.superimpose != null
  }
}